export default __webpack_public_path__ + "3c9cfeec16f757bf9df77c4491fec707.png";